<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    editTitle="Edição de Agrotóxico"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        :readOnly="readOnly"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_AGROTOXIC_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.adminContext.agrotoxic;
          this.extraData = response.data;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(agrotoxic) {
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_AGROTOXIC_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(agrotoxic, this.editableEntry.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateAgrotoxic.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_AGROTOXIC_QUERY = gql `
  query ($id: ID!) { 
    adminContext {
      agrotoxic (id: $id) {
        id
        description
        barcode
        taxationGroupId                
        brandId
        brand {
          name
        }
        unitId
        unit {
          name
        }
        groupId
        group {
          id
          name
        }
        packagingIds
        agrotoxicActiveIngredientsAttributes {
          id
          activeIngredientId
          activeIngredient {
            id
            name
          }
          concentration
          validations
        }
        validations
      }
    }
    globalContext {
      allUnits {
        id
        name
      }
    } 
    accountGlobalSharedContext {
      allBrandsOfItems {
        id
        name
      }
      allGroupsForAgrotoxics {
        id
        name
      }
    }
  }
`;

const UPDATE_AGROTOXIC_MUTATION = gql `
  mutation($input: AgrotoxicUpdateInputObject!) {
    updateAgrotoxic(input: $input) {
      item {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>